import Splide from "@splidejs/splide/dist/js/splide.min.js";

export default function Carousel() {
  // Hero slider
  // document.querySelectorAll('[data-carousel="hero"]').forEach((el) => {
  //   new Splide(el, {
  //     type: "fade",
  //     autoplay: true,
  //     interval: 5000,
  //     pauseOnHover: false,
  //     arrows: false,
  //     pagination: false,
  //   }).mount();
  // });

  // Comparison table
  document
    .querySelectorAll('[data-carousel="comparison-table"]')
    .forEach((el) => {
      const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches;

      const slidesCount = el.querySelectorAll(".splide__slide").length;

      const splide = new Splide(el, {
        mediaQuery: "min",
        perPage: 1,
        perMove: 1,
        gap: "var(--space-m)",
        arrows: false,
        pagination: false,
        speed: prefersReducedMotion ? 0 : 300,
        keyboard: true,
        slideFocus: false,
        breakpoints: {
          608: { perPage: Math.min(slidesCount, 2) },
          880: { perPage: Math.min(slidesCount, 3) },
          1120: { perPage: Math.min(slidesCount, 4) },
          1536: { perPage: Math.min(slidesCount, 6) },
        },
      });

      // Sync heights of table elements
      const syncHeights = () => {
        const visibleSlides = el.querySelectorAll(
          ".splide__slide.is-visible .c-comparison-table-card",
        );

        if (!visibleSlides.length) return;

        // Sync heading height
        const headings = Array.from(visibleSlides)
          .map((slide) =>
            slide.querySelector(".c-comparison-table-card__heading"),
          )
          .filter(Boolean);

        if (headings.length) {
          // Reset first
          headings.forEach((heading) => (heading.style.height = "auto"));

          const maxHeadingHeight = Math.max(
            ...headings.map((heading) => heading.offsetHeight),
          );

          headings.forEach(
            (heading) => (heading.style.height = `${maxHeadingHeight}px`),
          );
        }

        // Sync lede height
        const ledes = Array.from(visibleSlides)
          .map((slide) => slide.querySelector(".c-comparison-table-card__lede"))
          .filter(Boolean);

        if (ledes.length) {
          // Reset first
          ledes.forEach((lede) => (lede.style.height = "auto"));

          const maxLedeHeight = Math.max(
            ...ledes.map((lede) => lede.offsetHeight),
          );

          ledes.forEach((lede) => (lede.style.height = `${maxLedeHeight}px`));
        }

        // Sync feature group height
        const featureGroups = visibleSlides[0].querySelectorAll(
          ".c-comparison-table-card__feature-group",
        );

        visibleSlides.forEach((slide) => {
          slide
            .querySelectorAll(".c-comparison-table-card__feature-group")
            .forEach((group) => (group.style.height = "auto"));
        });

        featureGroups.forEach((_, index) => {
          let maxHeight = 0;

          visibleSlides.forEach((slide) => {
            const group = slide.querySelectorAll(
              ".c-comparison-table-card__feature-group",
            )[index];
            if (group) maxHeight = Math.max(maxHeight, group.offsetHeight);
          });

          visibleSlides.forEach((slide) => {
            const group = slide.querySelectorAll(
              ".c-comparison-table-card__feature-group",
            )[index];
            if (group) group.style.height = `${maxHeight}px`;
          });
        });
      };

      splide.mount();

      // Custom arrows
      const prevArrow = document.querySelector(
        '[data-carousel-prev="comparison-table"]',
      );
      const nextArrow = document.querySelector(
        '[data-carousel-next="comparison-table"]',
      );

      prevArrow?.addEventListener("click", () => splide.go("<"));
      nextArrow?.addEventListener("click", () => splide.go(">"));

      // Enable / disable arrows at boundaries
      const updateArrows = () => {
        const slides = splide.length;
        const perPage = splide.options.perPage;
        const shouldShow = slides > perPage;
        if (!prevArrow || !nextArrow) return;

        // Only show arrows if carousel is visible
        if (!carouselInView) {
          prevArrow.style.display = "none";
          nextArrow.style.display = "none";
          return;
        }

        prevArrow.style.display = shouldShow ? "flex" : "none";
        nextArrow.style.display = shouldShow ? "flex" : "none";

        const canGoPrev = splide.index > 0;
        const canGoNext = splide.index < slides - perPage;

        prevArrow.disabled = !canGoPrev;
        nextArrow.disabled = !canGoNext;

        prevArrow.classList.toggle("is-disabled", !canGoPrev);
        nextArrow.classList.toggle("is-disabled", !canGoNext);
      };

      // Track if carousel is in viewport
      let carouselInView = false;
      const observer = new IntersectionObserver(
        ([entry]) => {
          carouselInView = entry.isIntersecting;
          updateArrows();
        },
        { threshold: 0.1 },
      );
      observer.observe(el);

      // Run on Splide lifecycle events
      splide.on("mounted move resized", () => {
        updateArrows();
        requestAnimationFrame(syncHeights);
      });

      // Fonts can change heights after mount
      if (document.fonts?.ready) {
        document.fonts.ready.then(() => {
          syncHeights();
        });
      }
    });

  // Large cards
  document.querySelectorAll('[data-carousel="large-cards"]').forEach((el) => {
    // Reduced motion
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    // Inject styles once for all instances
    if (!document.getElementById("large-cards-carousel-styles")) {
      const style = document.createElement("style");
      style.id = "large-cards-carousel-styles";
      style.textContent = `
      [data-carousel="large-cards"] .splide__slide {
        flex: 0 0 auto;
      }
      [data-carousel="large-cards"] .is-disabled {
        opacity: 0.25;
        pointer-events: none;
      }
    `;
      document.head.appendChild(style);
    }

    // Container-relative padding
    const rootStyles = getComputedStyle(document.documentElement);
    const containerMaxRem = parseFloat(
      rootStyles.getPropertyValue("--wrapper"),
    );
    const rootFontSize = parseFloat(rootStyles.fontSize);
    const containerMaxPx = containerMaxRem * rootFontSize;

    const pct = (fraction) => Math.round(containerMaxPx * fraction) + "px";

    // Splide init
    const splide = new Splide(el, {
      type: "slide",
      rewind: true,
      perPage: 1,
      perMove: 1,
      gap: "var(--space-l)",
      arrows: false,
      pagination: false,
      speed: prefersReducedMotion ? 0 : 300,
      rewindSpeed: prefersReducedMotion ? 0 : 400,
      keyboard: true,
      slideFocus: false,
      trimSpace: false,
      mediaQuery: "min",
      padding: { right: pct(0.05) },
      breakpoints: {
        608: { padding: { right: pct(0.1) } },
        880: { padding: { right: pct(0.15) } },
        1120: { padding: { right: pct(0.25) } },
      },
    });

    splide.mount();

    // Custom arrows
    const section = el.closest("section");
    const prevArrow = section?.querySelector(
      '[data-carousel-prev="large-cards"]',
    );
    const nextArrow = section?.querySelector(
      '[data-carousel-next="large-cards"]',
    );

    prevArrow?.addEventListener("click", () => splide.go("<"));
    nextArrow?.addEventListener("click", () => splide.go(">"));

    // Arrow state sync
    function syncControls() {
      if (!prevArrow || !nextArrow) return;

      const endIndex = splide.Components.Controller.getEnd();
      const canGoPrev = splide.index > 0;
      const canGoNext = splide.index < endIndex;

      prevArrow.disabled = !canGoPrev;
      nextArrow.disabled = !canGoNext;
      prevArrow.classList.toggle("is-disabled", !canGoPrev);
      nextArrow.classList.toggle("is-disabled", !canGoNext);
    }

    splide.on("mounted move resized", syncControls);
  });

  // Related content carousel
  document
    .querySelectorAll('[data-carousel="related-content"]')
    .forEach((el) => {
      const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches;

      const rootStyles = getComputedStyle(document.documentElement);
      const containerMaxRem = parseFloat(
        rootStyles.getPropertyValue("--wrapper"),
      );
      const rootFontSize = parseFloat(rootStyles.fontSize);
      const containerMaxPx = containerMaxRem * rootFontSize;

      const pct = (fraction) => Math.round(containerMaxPx * fraction) + "px";

      const slideCount = el.querySelectorAll(".splide__slide").length;

      const splide = new Splide(el, {
        type: "slide",
        rewind: true,
        perPage: 1,
        perMove: 1,
        gap: "var(--space-l)",
        arrows: false,
        pagination: false,
        speed: prefersReducedMotion ? 0 : 300,
        rewindSpeed: prefersReducedMotion ? 0 : 400,
        keyboard: true,
        slideFocus: false,
        trimSpace: true,
        mediaQuery: "min",
        padding: { right: pct(0.05) },
        breakpoints: {
          608: { perPage: 1, padding: { right: pct(0.2) } },
          880: { perPage: 2, padding: { right: pct(0.15) } },
          1120: { perPage: 4, padding: { right: pct(0.05) } },
        },
      });

      splide.mount();

      const container = el.closest(".c-related-content-carousel");

      const prevArrow = container?.querySelector(
        '[data-carousel-prev="related-content"]',
      );
      const nextArrow = container?.querySelector(
        '[data-carousel-next="related-content"]',
      );
      const arrowsWrapper = container?.querySelector(
        ".c-related-content-carousel__arrows",
      );

      const navButtons = container?.querySelectorAll(
        '[data-carousel-nav="related-content"]',
      );

      const titleIndices = Array.from(navButtons ?? []).map((btn) =>
        parseInt(btn.dataset.slideIndex, 10),
      );

      function getActiveTitleIndex(currentIndex) {
        for (let i = titleIndices.length - 1; i >= 0; i--) {
          if (currentIndex >= titleIndices[i]) return titleIndices[i];
        }
        return titleIndices[0];
      }

      prevArrow?.addEventListener("click", () => splide.go("<"));
      nextArrow?.addEventListener("click", () => splide.go(">"));

      navButtons?.forEach((btn) => {
        btn.addEventListener("click", () => {
          splide.go(parseInt(btn.dataset.slideIndex, 10));
        });
      });

      function syncNavButtons() {
        if (!navButtons?.length) return;
        const activeTitleIndex = getActiveTitleIndex(splide.index);
        navButtons.forEach((btn) => {
          const isActive =
            parseInt(btn.dataset.slideIndex, 10) === activeTitleIndex;
          btn.setAttribute("aria-current", isActive ? "true" : "false");
          btn.classList.toggle("is-active", isActive);
          btn.classList.toggle("c-pill--petrol", isActive);
          btn.classList.toggle("c-pill--white", !isActive);
        });
      }

      function syncSlideWidths() {
        const perPage = splide.options.perPage;
        el.style.setProperty("--slide-count", slideCount);
        el.style.setProperty("--per-page", perPage);
      }

      function syncControls() {
        if (!prevArrow || !nextArrow) return;

        const endIndex = splide.Components.Controller.getEnd();
        const isScrollable = endIndex > 0;
        const canGoPrev = isScrollable && splide.index > 0;
        const canGoNext = isScrollable && splide.index < endIndex;

        if (arrowsWrapper) {
          if (isScrollable) {
            arrowsWrapper.removeAttribute("hidden");
          } else {
            arrowsWrapper.setAttribute("hidden", "");
          }
        }

        prevArrow.disabled = !canGoPrev;
        nextArrow.disabled = !canGoNext;
        prevArrow.classList.toggle("is-disabled", !canGoPrev);
        nextArrow.classList.toggle("is-disabled", !canGoNext);
      }

      splide.on("mounted move resized", syncControls);
      splide.on("mounted move resized", syncNavButtons);
      splide.on("mounted resized", syncSlideWidths);

      el.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", (e) => e.stopPropagation());
      });
    });

  // Accessory card carousel
  document
    .querySelectorAll('[data-carousel="accessory-cards"]')
    .forEach((el) => {
      // Reduced motion
      const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches;

      // Container-relative padding
      const rootStyles = getComputedStyle(document.documentElement);
      const containerMaxRem = parseFloat(
        rootStyles.getPropertyValue("--wrapper"),
      );
      const rootFontSize = parseFloat(rootStyles.fontSize);
      const containerMaxPx = containerMaxRem * rootFontSize;

      const pct = (fraction) => Math.round(containerMaxPx * fraction) + "px";

      const slideCount = el.querySelectorAll(".splide__slide").length;

      // Splide init
      const splide = new Splide(el, {
        type: "slide",
        rewind: true,
        perPage: 1,
        perMove: 1,
        gap: "var(--space-l)",
        arrows: false,
        pagination: false,
        speed: prefersReducedMotion ? 0 : 300,
        rewindSpeed: prefersReducedMotion ? 0 : 400,
        keyboard: true,
        slideFocus: false,
        trimSpace: true,
        mediaQuery: "min",
        padding: { right: pct(0.05) },
        breakpoints: {
          608: { perPage: 1, padding: { right: pct(0.2) } },
          880: { perPage: 2, padding: { right: pct(0.15) } },
          1120: { perPage: 4, padding: 0 },
        },
      });

      splide.mount();

      const container = el.closest(".c-accessory-carousel");

      // Custom arrows
      const prevArrow = container?.querySelector(
        '[data-carousel-prev="accessory-cards"]',
      );
      const nextArrow = container?.querySelector(
        '[data-carousel-next="accessory-cards"]',
      );
      const arrowsWrapper = container?.querySelector(".c-carousel-arrows");

      prevArrow?.addEventListener("click", () => splide.go("<"));
      nextArrow?.addEventListener("click", () => splide.go(">"));

      // Navigation buttons
      const navButtons = container?.querySelectorAll(
        '[data-carousel-nav="accessory-cards"]',
      );

      const titleIndices = Array.from(navButtons ?? []).map((btn) =>
        parseInt(btn.dataset.slideIndex, 10),
      );

      navButtons?.forEach((btn) => {
        btn.addEventListener("click", () => {
          splide.go(parseInt(btn.dataset.slideIndex, 10));
        });
      });

      function getActiveTitleIndex(currentIndex) {
        for (let i = titleIndices.length - 1; i >= 0; i--) {
          if (currentIndex >= titleIndices[i]) return titleIndices[i];
        }
        return titleIndices[0];
      }

      function syncNavButtons() {
        if (!navButtons?.length) return;
        const activeTitleIndex = getActiveTitleIndex(splide.index);
        navButtons.forEach((btn) => {
          const isActive =
            parseInt(btn.dataset.slideIndex, 10) === activeTitleIndex;
          btn.setAttribute("aria-current", isActive ? "true" : "false");
          btn.classList.toggle("is-active", isActive);
          btn.classList.toggle("c-pill--petrol", isActive);
          btn.classList.toggle("c-pill--white", !isActive);
        });
      }

      function syncSlideWidths() {
        const perPage = splide.options.perPage;
        el.style.setProperty("--slide-count", slideCount);
        el.style.setProperty("--per-page", perPage);
      }

      function syncControls() {
        if (!prevArrow || !nextArrow) return;

        const endIndex = splide.Components.Controller.getEnd();
        const isScrollable = endIndex > 0;
        const canGoPrev = isScrollable && splide.index > 0;
        const canGoNext = isScrollable && splide.index < endIndex;

        if (arrowsWrapper) {
          if (isScrollable) {
            arrowsWrapper.removeAttribute("hidden");
          } else {
            arrowsWrapper.setAttribute("hidden", "");
          }
        }

        prevArrow.disabled = !canGoPrev;
        nextArrow.disabled = !canGoNext;
        prevArrow.classList.toggle("is-disabled", !canGoPrev);
        nextArrow.classList.toggle("is-disabled", !canGoNext);
      }

      splide.on("mounted move resized", syncControls);
      splide.on("mounted move resized", syncNavButtons);
      splide.on("mounted resized", syncSlideWidths);

      el.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", (e) => e.stopPropagation());
      });
    });
}
